/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { PageconfigurationsContext, usePageconfigurationsContext } from './pageconfigurations-context'
import type * as Fetcher from './pageconfigurations-fetcher'
import { pageconfigurationsFetch } from './pageconfigurations-fetcher'
import type * as Schemas from './pageconfigurations-schemas'

export type PageRequestGetPathParams = {
  templateBasePath: string
  id: string
}

export type PageRequestGetHeaders = {
  ['X-Locale']?: string
}

export type PageRequestGetError = Fetcher.ErrorWrapper<{
  status: 404
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type PageRequestGetVariables = {
  headers?: PageRequestGetHeaders
  pathParams: PageRequestGetPathParams
} & PageconfigurationsContext['fetcherOptions']

/**
 * Returns the details of the Page
 */
export const fetchPageRequestGet = (variables: PageRequestGetVariables, signal?: AbortSignal) =>
  pageconfigurationsFetch<Schemas.Page, PageRequestGetError, undefined, PageRequestGetHeaders, {}, PageRequestGetPathParams>({
    url: '/{templateBasePath}/pages/{id}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the details of the Page
 */
export const usePageRequestGet = <TData = Schemas.Page>(
  variables: PageRequestGetVariables,
  options?: Omit<reactQuery.UseQueryOptions<Schemas.Page, PageRequestGetError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = usePageconfigurationsContext(options)
  return reactQuery.useQuery<Schemas.Page, PageRequestGetError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/pages/{id}',
      operationId: 'pageRequestGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchPageRequestGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/{templateBasePath}/pages/{id}'
  operationId: 'pageRequestGet'
  variables: PageRequestGetVariables
}
